import React, {Component} from "react";
import packageJson from '../../../../package.json';

export const VersionDisplay = () => <div className="version">v{packageJson.version}</div>
